export default "__VITE_ASSET__BvW$51Oh__"